import createLucideIcon from '../createLucideIcon';

/**
 * @component @name RulerDimensionLine
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTV2LTMiIC8+CiAgPHBhdGggZD0iTTE0IDE1di0zIiAvPgogIDxwYXRoIGQ9Ik0xOCAxNXYtMyIgLz4KICA8cGF0aCBkPSJNMiA4VjQiIC8+CiAgPHBhdGggZD0iTTIyIDZIMiIgLz4KICA8cGF0aCBkPSJNMjIgOFY0IiAvPgogIDxwYXRoIGQ9Ik02IDE1di0zIiAvPgogIDxyZWN0IHg9IjIiIHk9IjEyIiB3aWR0aD0iMjAiIGhlaWdodD0iOCIgcng9IjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/ruler-dimension-line
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const RulerDimensionLine = createLucideIcon('ruler-dimension-line', [
  ['path', { d: 'M10 15v-3', key: '1pjskw' }],
  ['path', { d: 'M14 15v-3', key: '1o1mqj' }],
  ['path', { d: 'M18 15v-3', key: 'cws6he' }],
  ['path', { d: 'M2 8V4', key: '3jv1jz' }],
  ['path', { d: 'M22 6H2', key: '1iqbfk' }],
  ['path', { d: 'M22 8V4', key: '16f4ou' }],
  ['path', { d: 'M6 15v-3', key: '1ij1qe' }],
  ['rect', { x: '2', y: '12', width: '20', height: '8', rx: '2', key: '1tqiko' }],
]);

export default RulerDimensionLine;
